import moment from 'moment-timezone';
moment.tz.setDefault("America/Sao_Paulo");

const dateISO2Front = (date, time=false) => {
    let wrapped = moment(date);//.tz("America/Sao_Paulo");
    if(time){
        let dtFomated = wrapped.format("DD/MM/YYYY HH:mm:ss");
        return dtFomated;
    } else {
        let dtFomated = wrapped.format("DD/MM/YYYY");
        return dtFomated;
    }
}

export const date2Front = (date) =>{
    if(date){
        return dateISO2Front(date);
    }
}

export const datetime2Front = (date) =>{
    return dateISO2Front(date,true);
}

export const toNumber = str => {
    return parseInt(str.toString().replace(/\D/g,''));
}